import { useEffect } from 'react';

interface LightboxProps {
  image: string;
  onClose: () => void;
}

export default function Lightbox({ image, onClose }: LightboxProps) {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 cursor-pointer"
      onClick={onClose}
    >
      {/* Close Button */}
      <button
        onClick={onClose}
        className="absolute top-6 right-6 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center text-white text-2xl transition-colors cursor-pointer"
        aria-label="Fechar"
      >
        <i className="ri-close-line"></i>
      </button>

      {/* Image */}
      <div
        className="relative max-w-5xl max-h-[90vh] cursor-default"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={image}
          alt="Produto"
          className="w-full h-full object-contain"
        />
      </div>
    </div>
  );
}